<template>
	<inertia-head title="Checkout" />
	<h2 class="text-center">Congratulations For Taking Action!</h2>
	<h6 class="text-center">Please follow The Steps To Enroll TODAY!</h6>
	<form @submit.prevent="submit">
		<div class="row">
			<div class="col-md-12">
				<div class="row">
					<div class="col-md-6">
						<div class="form-floating mb-4">
							<input
								id="fname"
								v-model="form.fname"
								:class="{ 'is-invalid': form.errors.fname }"
								type="text"
								class="form-control"
								placeholder="Enter your fname"
							/>
							<label class="form-label" for="fname">First Name</label>
							<div v-if="form.errors.fname" class="invalid-feedback">
								<i class="fa fa-exclamation-circle"></i>
								{{ form.errors.fname }}
							</div>
						</div>
					</div>
					<div class="col-md-6">
						<div class="form-floating mb-4">
							<input
								id="lname"
								v-model="form.lname"
								:class="{ 'is-invalid': form.errors.lname }"
								type="text"
								class="form-control"
								placeholder="Enter your lname"
							/>
							<label class="form-label" for="lname">Last Name</label>
							<div v-if="form.errors.lname" class="invalid-feedback">
								<i class="fa fa-exclamation-circle"></i>
								{{ form.errors.lname }}
							</div>
						</div>
					</div>
				</div>
				<div class="row">
					<div class="col-md-6">
						<div class="form-floating mb-4">
							<input
								id="email"
								v-model="form.email"
								:class="{ 'is-invalid': form.errors.email }"
								type="text"
								class="form-control"
								placeholder="Enter your email"
							/>
							<label class="form-label" for="email">Email address</label>
							<div v-if="form.errors.email" class="invalid-feedback">
								<i class="fa fa-exclamation-circle"></i>
								{{ form.errors.email }}
							</div>
						</div>
					</div>
					<div class="col-md-6">
						<div class="form-floating mb-4">
							<flat-pickr
								id="bday"
								v-model="form.bday"
								:class="
									form.errors.bday
										? 'flatpickr-input is-invalid border-danger'
										: 'flatpickr-input'
								"
								class="form-control"
								placeholder="Enter your bday"
							/>
							<label class="form-label" for="bday">Birthday</label>
							<div v-if="form.errors.bday" class="invalid-feedback">
								<i class="fa fa-exclamation-circle"></i>
								{{ form.errors.bday }}
							</div>
						</div>
					</div>
				</div>
				<div class="mb-4">
					<vue-tel-input
						:id="'mobile'"
						v-model="form.mobile"
						@input="onInput"
						@countryChanged="onCountryChange"
						defaultCountry="PH"
						mode="international"
						:class="{ 'is-invalid': form.errors.mobile }"
						class="form-control"
						:input-options="{
							placeholder: 'Enter mobile number',
						}"
					/>
					<div v-if="form.errors.mobile" class="invalid-feedback">
						<i class="fa fa-exclamation-circle"></i>
						{{ form.errors.mobile }}
					</div>
				</div>
			</div>
		</div>
		<div class="row g-sm">
			<div class="col-12 mb-2">
				<button
					type="submit"
					class="btn btn-lg btn-alt-primary w-100 py-3 fw-semibold"
					:disabled="form.processing"
				>
					<div
						v-if="form.processing"
						class="spinner-border spinner-border-sm text-text"
						role="status"
					>
						<span class="sr-only">Loading...</span>
					</div>
					<span v-if="!form.processing">
						Next
					</span>
				</button>
			</div>
		</div>
	</form>
	<div class="block-content text-center">
		<div class="mt-3">Your referring affiliate is: {{ sponsor ?? 'None' }}</div>
	</div>
</template>

<script>
import GuestLayout from '../Layouts/GuestLayout'

window.dataLayer = window.dataLayer || [];
function gtag(){dataLayer.push(arguments);}
gtag('js', new Date());

gtag('config', window.gtag_id);

export default { layout: GuestLayout }
</script>

<script setup>
import { useForm } from '@inertiajs/inertia-vue3'
import { ref, watch } from 'vue'

const props = defineProps({
	sponsor: String,
	c_source: String,
	flash: Object,
})

const form = useForm({
	fname: null,
	lname: null,
	email: null,
	username: null,
	mobile: null,
	country_code: null,
	country_calling_code: null,
	bday: null,
	subscription: null,
	c_source: props.c_source,
})

const onInput = (number, phoneObject) => {
	if (phoneObject?.formatted) {
		form.mobile = phoneObject.number
		form.country_calling_code = phoneObject.countryCallingCode
	// }else
	// {
	// 	form.mobile = "";
	}
}

const onCountryChange = (countryObject) => {
	form.country_code = countryObject.iso2
}


const submit = () => {
	form
		.transform((data) => ({
			...data,
			username: data.email,
		}))
		.post(route('post.checkout-free'), {
			preserveState: true,
			preserveScroll: true,
			onError: (errors)=>{
				
				var fields = ['fname','lname','email','bday','mobile'];
				//Check if error exist and focus the first field.
				for (var i = 0; i < fields.length; i++) {

					var found = false;

					for (const [key, value] of Object.entries(form)) {

						if(fields[i]==key){

							if(form.errors[key]){
								var  el = document.getElementById(key);
								if(key=='mobile'){
									el = document.getElementsByClassName("vti__input")[0];
								}else if(key=='subscription'){
									el = document.getElementsByClassName("subscription")[0];
								}

								el.focus();	

								found = true;

								break;
							}
						}
					}

					if(found==true){
						break;
					}
				}
			}
		})
}

</script>
